import React from 'react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar"
import { Link, useNavigate } from "react-router-dom";
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";

interface UserNavProps {
    userName?: string;
}

export const UserNav: React.FC<UserNavProps> = ({ userName }) => {
    const navigate = useNavigate();
    const { toast } = useToast();

    const handleSignOut = async () => {
        const { error } = await supabase.auth.signOut();

        if (error) {
            toast({
                title: "Error signing out",
                description: "There was an error signing you out. Please try again.",
                variant: "destructive",
            });
        } else {
            localStorage.setItem('explicitly_logged_out', 'true');
            toast({
                title: "Signed out",
                description: "You have been successfully signed out.",
            });
            navigate('/landing');
        }
    };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="rounded-full h-9 w-9 flex items-center justify-center">
          <Avatar className="h-9 w-9">
            <AvatarImage src="/avatars/01.png" alt="Avatar" />
            <AvatarFallback>CN</AvatarFallback>
          </Avatar>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-56" align="end" forceMount>
        <DropdownMenuItem className="focus:outline-none">
          <Link to="/profile" className="w-full h-full block">
            Profile
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem className="focus:outline-none">
          <Link to="/billing" className="w-full h-full block">
            Billing
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem className="focus:outline-none">
          <Link to="/settings" className="w-full h-full block">
            Settings
          </Link>
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={handleSignOut} className="focus:outline-none">
          Sign out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
